import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invalid-store',
  templateUrl: './invalid-store.component.html',
  styleUrls: ['./invalid-store.component.scss']
})
export class InvalidStoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
